'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.directive('otppServiceModule', function() {
  return {
    restrict: 'E',
    templateUrl: 'scripts/directives/otpp-pension-modules/service-module.prt.html'
  };
});
